<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <v-btn icon small flat color="primary" @click="closeDayView">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-btn color="primary" icon @click="previousWeek">
            <v-icon>first_page</v-icon>
          </v-btn>
          <v-btn color="primary" icon @click="previousDay">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-btn color="primary" icon @click="nextDay">
            <v-icon>chevron_right</v-icon>
          </v-btn>
          <v-btn color="primary" icon @click="nextWeek">
            <v-icon>last_page</v-icon>
          </v-btn>
          <v-btn color="primary" icon @click="today">
            <v-icon>today</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-menu
            ref="dateMenu"
            :close-on-content-click="false"
            v-model="dateDialog"
            :nudge-right="40"
            :return-value.sync="date"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px">
            <v-text-field
            slot="activator"
            v-model="dateFmt"
            prepend-inner-icon="event"
            solo-inverted
            flat
            color="white"
            readonly></v-text-field>
            <v-date-picker v-model="date" @input="saveDate(date)"></v-date-picker>
          </v-menu>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 v-if="gettingEvents" class="text-xs-center">
              <v-progress-circular :size="70" :width="10" indeterminate color="primary"></v-progress-circular>
            </v-flex>
            <v-flex xs12 v-else-if="fcEvents.length > 0">
              <v-list two-line>
                <v-list-group v-for="(job, index) in fcEvents" :key="index">
                  <v-list-tile slot="activator" avatar>
                    <v-list-tile-avatar>
                      <v-badge right overlap>
                        <v-icon large>assignment</v-icon>
                        <span slot="badge" small>{{job.templates.length}}</span>
                      </v-badge>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{job.JobNo}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{'Vehicle - ' + job.vehReg}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-layout wrap>
                    <v-flex xs11 offset-xs1>
                      <v-list>
                        <v-list-tile>
                          <v-list-tile-content>
                            <span>{{'Engineer: ' + engineerName(job.engineer)}}</span>
                            <span>{{'Customer: ' + customers[job.Customer]}}</span>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                      <v-list dense dark>
                        <v-list-tile v-for="(template, templateIndex) in job.templates" :key="templateIndex">
                          <v-list-tile-content>
                            <v-list-tile-title>{{templateName(template)}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-list-group>
              </v-list>
            </v-flex>
            <v-flex xs12 v-else class="text-xs-center">
              <h3>No jobs found for this day</h3>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import {fireStore} from '../firebase'
import moment from 'moment'
export default {
  props: ['Day', 'Supplier', 'viewingDay', 'templates', 'engineers', 'customers'],
  data () {
    return {
      gettingEvents: false,
      fcEvents: [],
      dateDialog: false,
      date: null
    }
  },
  mounted () {
    this.getEvents()
  },
  filters: {
    titleDate: function (val) {
      return moment(val).format('DD/MM/YYYY')
    }
  },
  watch: {
    Day: function (val) {
      this.date = moment(this.Day).format('YYYY-MM-DD')
      this.getEvents()
    }
  },
  computed: {
    dateFmt () {
      return moment(this.date).format('DD/MM/YYYY')
    }
  },
  methods: {
    saveDate (date) {
      this.$refs.dateMenu.save(date)
      this.date = moment(date).format('YYYY-MM-DD')
      this.$emit('update:Day', moment(date).toDate())
    },
    engineerName (val) {
      console.log(val)
      const index = this.engineers.findIndex(obj => {
        return obj.key === val
      })
      console.log(index)
      return this.engineers[index]['name']
    },
    templateName (val) {
      console.log(val)
      const index = this.templates.findIndex(obj => {
        return obj.id === val
      })
      console.log(index)
      return this.templates[index]['name']
    },
    closeDayView () {
      this.$emit('update:viewingDay', false)
    },
    getEvents () {
      this.gettingEvents = true
      this.fcEvents = []
      if (this.Supplier) {
        fireStore.collection('Jobs')
        .where('Supplier', '==', this.Supplier)
        .where('Date', '==', moment(this.Day).format('YYYY-MM-DD'))
        .get()
        .then(docs => {
          docs.forEach(doc => {
            this.fcEvents.push({
              vehReg: doc.data().vehReg,
              JobNo: doc.data().JobNo,
              startDate: doc.data().Date,
              endDate: doc.data().Date,
              Status: doc.data().Status,
              Supplier: doc.data().Supplier,
              engineer: doc.data().Allocated,
              Customer: doc.data().Customer,
              templates: doc.data().templates,
              id: doc.data().id
            })
          })
          this.gettingEvents = false
        })
      } else {
        fireStore.collection('Jobs')
        .where('Date', '==', moment(this.Day).format('YYYY-MM-DD'))
        .get()
        .then(docs => {
          docs.forEach(doc => {
            this.fcEvents.push({
              vehReg: doc.data().vehReg,
              JobNo: doc.data().JobNo,
              startDate: doc.data().Date,
              endDate: doc.data().Date,
              Status: doc.data().Status,
              Supplier: doc.data().Supplier,
              engineer: doc.data().Allocated,
              Customer: doc.data().Customer,
              templates: doc.data().templates,
              id: doc.data().id
            })
          })
          this.gettingEvents = false
        })
      }
    },
    previousWeek () {
      this.saveDate(moment(this.Day).subtract(1, 'weeks').toDate())
    },
    previousDay () {
      this.saveDate(moment(this.Day).subtract(1, 'days').toDate())
    },
    nextDay () {
      this.saveDate(moment(this.Day).add(1, 'days').toDate())
    },
    nextWeek () {
      this.saveDate(moment(this.Day).add(1, 'weeks').toDate())
    },
    today () {
      this.saveDate(moment().toDate())
    }
  }
}
</script>


// WEBPACK FOOTER //
// DayView.vue?0875918e